import { version } from "../package.json.js";
const devMsg = slug => {
  return `https://prismic.dev/msg/client/v${version}/${slug}`;
};
export { devMsg };
